import React from 'react';
import { Images } from 'utils';
import { FullTable } from 'components';
import {
  carrierInsuranceInfoBody,
  carrierInsuranceInfoHead,
  carrierSafetyInfoBody,
  carrierSafetyInfoHead,
} from './constants';
import { useSelector } from 'react-redux';

export const SafetyCompliance = ({}) => {
  const { carrierById } = useSelector((state) => ({
      carrierById: state.carriers.carrierById,
    }),
  );
  const safety = carrierById?.safetyCompliance;

  return (
    <div>
      <div className="insurance-info-wrapper">
        <div>
          <p>Safety Rating</p>
          <h6>{safety?.safetyRating}</h6>
        </div>
        <div>
          <p>Inspection History Present</p>
          <img src={safety?.inspectionHistoryPresent ? Images.domeMark : Images.failMark} alt="domeMark" />
        </div>
        <div>
          <p>Enterprise Verified</p>
          <img src={safety?.enterpriseVerified ? Images.domeMark : Images.failMark} alt="domeMark" />
        </div>
      </div>


      <div className="flex-align-start" style={{ gap: 16, width: '100%' }}>
      <div className="full-width">
          <p className="insurance-info-title">Trucks</p>
          <div className="insurance-info-wrapper">
            <div>
              <p>Owned</p>
              <h6>{safety?.trucks?.owned}</h6>
            </div>
            <div>
              <p>Term Leased</p>
              <h6>{safety?.trucks?.termLeased}</h6>
            </div>
          </div>
        </div>

        <div className="full-width">
          <p className="insurance-info-title">Trailers</p>
          <div className="insurance-info-wrapper">
            <div>
              <p>Owned</p>
              <h6>{safety?.trailers?.owned}</h6>
            </div>
            <div>
              <p>Term Leased</p>
              <h6>{safety?.trailers?.termLeased}</h6>
            </div>
          </div>
        </div>
      </div>

      <p className="insurance-info-title">Rule Classifications</p>
      <FullTable
        margin={'8px 0 0 0'}
        head={carrierSafetyInfoHead}
        body={carrierSafetyInfoBody}
        list={safety?.ruleClassifications || []}
        noText={'Insurance Info'}
        height={'small'}
      />
    </div>
  );
};